import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=3f16b577&scoped=true&"
import script from "./AccountLayout.vue?vue&type=script&lang=ts&"
export * from "./AccountLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=3f16b577&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16b577",
  null
  
)

export default component.exports